module.exports = __webpack_public_path__ + "img/banner-3.056866f2.jpg";